angular.module("digitalLeasing.module").component("additionalCustomerInfo", {
    templateUrl: "ng/components/digitalLeasing/financialLeasingRequest/additionalCustomerInfo/additionalCustomerInfo.view.html",
    bindings: {
        model: "=",
        onStructureChanges: "&",
        preventivo:'<'
    },
    controllerAs: "additionalCustomerInfoCtrl",
    controller: AdditionalCustomerInfoController
});

function AdditionalCustomerInfoController(
    $portalService
) {
    var self = this;

    self.$onInit = function () {
        self.$portalService=$portalService;
    };

    self.handleChange = function(property, value){
        if (property) {
            self.model[property] = value;
        }
        self.onStructureChanges({customerInfoStructure: self.model});
        console.log("Additional Customer Info: ", self.model);
    }

}